export const FETCH_APPLICATION_REQUEST = 'FETCH_APPLICATION_REQUEST';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const SET_APPLICATION_COUNT = 'SET_APPLICATION_COUNT';
export const EVICT_APPLICATION_CACHE = 'EVICT_APPLICATION_CACHE';
export const FETCH_ALL_INBOUND_FORMS = 'FETCH_ALL_INBOUND_FORMS_SUCCESS';
export const FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST = 'FETCH_APPLICATION_FORM_CONVERSION_RATES_REQUEST';
export const FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS = 'FETCH_APPLICATION_FORM_CONVERSION_RATES_SUCCESS';
export const FETCH_AVAILABLE_PLATFORMS_SUCCESS = 'FETCH_AVAILABLE_PLATFORMS_SUCCESS';
